import { MdIconSearch, MdIconClose } from '@antiqua-dls/vue-components';
import { computed } from 'vue';

export default {
    name: 'SearchBar',
    components: {
        MdIconSearch,
        MdIconClose
    },

    props: {
        placeholder: {
            type: String,
            default: 'Search'
        },
        modelValue: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        },
        className: {
            type: String,
            default: ''
        },
        verticalPadding: {
            type: String,
            default: '20px'
        },
        horizontalPadding: {
            type: String,
            default: '24px'
        }
    },

    setup(props, { emit }) {
        const searchValue = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value)
        });

        const handleSearch = () => {
            emit('search', searchValue.value);
        };

        const handleEmptySearch = (event) => {
            if (!searchValue.value) {
                emit('empty-search', event);
            }
        };

        const clearSearch = () => {
            emit('update:modelValue', '');
            emit('clear');
        };

        const componentStyles = computed(() => ({
            '--search-vertical-padding': props.verticalPadding,
            '--search-horizontal-padding': props.horizontalPadding
        }));

        return {
            searchValue,
            handleSearch,
            handleEmptySearch,
            clearSearch,
            componentStyles
        }
    }
};
